"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REGISTRATION_ERROR_TEXT = exports.REGISTRATION = void 0;
var REGISTRATION;
(function (REGISTRATION) {
    REGISTRATION["firstName"] = "name";
    REGISTRATION["lastName"] = "surname";
    REGISTRATION["middleName"] = "secondName";
    REGISTRATION["birthDay"] = "birthDate";
    REGISTRATION["email"] = "email";
    REGISTRATION["phone"] = "phone";
})(REGISTRATION || (exports.REGISTRATION = REGISTRATION = {}));
exports.REGISTRATION_ERROR_TEXT = {
    firstName: 'Неверный формат',
    lastName: 'Неверный формат',
    middleName: 'Неверный формат',
    birthDay: 'Неверная дата',
    email: 'Неверный почтовый адрес',
    phone: 'Неверный номер телефона',
};
